import React, { Fragment } from "react";
import { Breakpoint } from 'react-socks';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router";
import ExtendedLink from "./ExtendedLink";
import TrustBoxReviewCountContainer from '../containers/TrustBoxReviewCountContainer';

export default function (props) {
    const { t } = useTranslation();
    const history = useHistory();
    const { settings } = props;

    const showTrustPilot = settings.trustPilotBusinessUnitId && settings.customDomain;
    return (
        <Fragment>
            <Breakpoint small down>
                <div className="mb-1" />
            </Breakpoint>
            <Breakpoint medium up>
                <div className="page-title">
                    <div className={`${(settings.isCatalogueMode ? "container-fluid" : "container")}`}>
                        <div className="column">
                            <h1>{props.title}</h1>
                        </div>
                        {showTrustPilot && <div className="column">
                            <TrustBoxReviewCountContainer />
                        </div>}
                        <div className="column">
                            <ul className="breadcrumbs">
                                {settings.isCatalogueMode !== true &&
                                    <Fragment>
                                        <li> <ExtendedLink to={`${settings.baseUrl}${settings.catalogueUrl}`}>{t("Home")} </ExtendedLink> </li>
                                        <li className="separator">&nbsp;</li>
                                        <li>{props.title}</li>
                                    </Fragment>
                                }
                                {settings.isPluginMode && <li>  <ExtendedLink to={`${settings.baseUrl}nearby-consultants`} className="btn btn-outline-primary btn-sm overflow-text" > {t("Consultant Search")} </ExtendedLink></li> }
                                {settings.isCatalogueMode && <li> <button className="btn btn-sm k-button btn-outline-primary btn-Catalogue-back" onClick={() => history.go(-1)}>{t("Go Back")} </button></li> }
                            </ul>
                        </div>
                    </div>
                </div>
            </Breakpoint>
        </Fragment>
    );
}


